/**
 * Whether chat speaks through local TTS (Kokoro) (SA-1392).
 *
 * Only where the deployment has local TTS (`localTts === true`, from
 * `useEdgeLocalConfig`), and then for a Kokoro persona or whenever voice is
 * on. A Kokoro persona anywhere else takes the ordinary TTS path, so it
 * never posts to a `/local-tts` route that is not there. Unknown counts as
 * absent.
 */
export function localTtsMode({
  localTts,
  personaUsesKokoro,
  ttsEnabled,
}: {
  localTts: boolean | null
  personaUsesKokoro: boolean
  ttsEnabled: boolean
}): boolean {
  return localTts === true && (personaUsesKokoro || ttsEnabled)
}
